import { notification } from 'antd';

/**
 * Normalizes an error response body into a human-readable string.
 *
 * Django Ninja / Pydantic validation errors (HTTP 422) return `detail` as
 * an array of objects like `{ type, loc, msg }` rather than a string.
 * Passing that array directly to antd's `notification({ description })`
 * would crash React ("Objects are not valid as a React child"), so we
 * flatten it into a readable message here.
 */
export const extractErrorMessage = (
  data: any,
  fallbackMessage = 'Something went wrong.',
): string => {
  const rawDetail = data?.detail || data?.error || data?.message;

  if (Array.isArray(rawDetail)) {
    return rawDetail.map((item) => item?.msg || JSON.stringify(item)).join(' ');
  }

  return rawDetail || fallbackMessage;
};

// shows standardized error/auth notifications
export const displayUnAuthorizedNotification = () => {
  // trigger the login modal to open
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('app:open-login'));
  }
};

export const somethingWentWrongNotification = () => {
  notification.error({
    message: 'Error!',
    description: `Something went wrong. Please try again.`,
  });
};
